import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import GameContainer from "./components/snake-game-container/game-container";

ReactDOM.render(<GameContainer />, document.getElementById("root"));
